import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Simple confirmation page shown after a customer taps a campaign-blast
// feedback button ("I have a cook" / "Order timing not matching"). MagicLogin
// redirects here once it confirms the click was logged, so the customer sees
// a clear "done" state instead of silently landing on the home page.
const MESSAGES = {
  cook: {
    heading: "Thanks for the update!",
    body: "We're glad to hear you already have a cook sorted.",
  },
  timing: {
    heading: "Thanks for letting us know",
    body: "We've noted the order timing issue and will look into it.",
  },
  default: {
    heading: "Thanks for your feedback!",
    body: "We've recorded your response.",
  },
};

export default function Response() {
  const location = useLocation();
  const navigate = useNavigate();
  const type = location.state?.type;
  const { heading, body } = MESSAGES[type] || MESSAGES.default;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 14,
        background: "#F8F6F0",
        padding: 24,
        textAlign: "center",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: "#6B8E23",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 28,
        }}
      >
        ✓
      </div>
      <h1
        style={{
          color: "#2C2C2C",
          fontSize: 20,
          fontWeight: 700,
          margin: 0,
        }}
      >
        {heading}
      </h1>
      <p
        style={{
          color: "#5a5a5a",
          fontSize: 15,
          maxWidth: 320,
          margin: 0,
          lineHeight: 1.5,
        }}
      >
        {body}
      </p>
      <p
        style={{
          color: "#9a9a9a",
          fontSize: 13,
          marginTop: 8,
        }}
      >
        You can close this window now.
      </p>
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: 12,
          background: "none",
          border: "none",
          color: "#6B8E23",
          fontSize: 13,
          textDecoration: "underline",
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        Continue to DailyDish
      </button>
    </div>
  );
}
